import { useMemo } from "react"
import { isJSONSchema7, SchemaForm } from "universal-schema/lib"

export const useJobPostProcessedData = (
    inputSchema: SchemaForm,
    responseData: unknown,
    postProcessTitle?: string
): { formData: unknown; schema: SchemaForm } => {
    return useMemo(() => {
        const { schema, uiSchema } = inputSchema
        if (responseData === null || responseData === undefined) {
            return { formData: undefined, schema: inputSchema }
        }
        const propertyKeys = Object.keys(schema.properties ?? {})
        if (
            schema.type === "object" &&
            schema.properties !== undefined &&
            propertyKeys.length === 1
        ) {
            const property = schema.properties[propertyKeys[0]]
            return {
                formData: {
                    [propertyKeys[0]]: responseData
                },
                schema: {
                    uiSchema,
                    schema: postProcessTitle
                        ? {
                              ...schema,
                              properties: {
                                  [propertyKeys[0]]: isJSONSchema7(property)
                                      ? {
                                            ...property,
                                            title: postProcessTitle
                                        }
                                      : property
                              }
                          }
                        : schema
                }
            }
        } else if (schema.type === "string") {
            return {
                formData: responseData,
                schema: {
                    uiSchema,
                    schema: postProcessTitle
                        ? { ...schema, title: postProcessTitle }
                        : schema
                }
            }
        }
        return { formData: undefined, schema: inputSchema }
    }, [inputSchema, responseData, postProcessTitle])
}
